import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { swalSuccess } from "../../utils/swalAlert";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const slug = params.get("slug");

  const navigate = useNavigate();

  useEffect(() => {
    swalSuccess({
      title: "پرداخت موفق",
      text: "پرداخت شما با موفقیت انجام شد.",
    }).then(() => {
      navigate("/panel/user/my-sites", { replace: true });
    });
  }, [navigate]);

  return null;
}
